(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["weekenders-background"] && !Shopify.designMode) return;
  try {
    (function(){
  let observer;
  function init(){
    const backdrop=document.querySelector('.wk-shared-backdrop');
    if(!backdrop)return;
    const hero=document.querySelector('.wk-hero');
    const world=document.querySelector('.wk-world');
    const target=(document.body.classList.contains('wk-continuous-full')||document.body.classList.contains('wk-continuous-shop'))?document.body:hero||document.querySelector('#MainContent');
    if(!target)return;
    function sync(){
      backdrop.style.setProperty('--wk-shared-height',Math.ceil(target.getBoundingClientRect().bottom-document.body.getBoundingClientRect().top)+'px');
      if(world){const style=getComputedStyle(world);backdrop.style.setProperty('--wk-shared-opacity',style.getPropertyValue('--wk-graffiti-opacity'));backdrop.style.setProperty('--wk-shared-glow',style.getPropertyValue('--wk-graffiti-glow'));backdrop.style.setProperty('--wk-shared-art',style.getPropertyValue('--wk-doodles'));}
    }
    if(observer)observer.disconnect();
    observer=new ResizeObserver(sync);observer.observe(target);
    const header=document.querySelector('.wk-header-shell');if(header)observer.observe(header);
    sync();document.fonts.ready.then(sync);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["weekenders-motion"] && !Shopify.designMode) return;
  try {
    (function(){if(window.wkSharedMotionBound)return;window.wkSharedMotionBound=true;document.addEventListener('click',event=>{const button=event.target.closest('.wk-global-motion');if(!button)return;const paused=document.documentElement.classList.toggle('wk-motion-paused');button.setAttribute('aria-pressed',String(paused));});})();
  } catch(e) { console.error(e); }
})();

})();
